import { render, staticRenderFns } from "./deleteApplyRoomDiscountType.vue?vue&type=template&id=04354dc5&scoped=true"
import script from "./deleteApplyRoomDiscountType.vue?vue&type=script&lang=js"
export * from "./deleteApplyRoomDiscountType.vue?vue&type=script&lang=js"
import style0 from "./deleteApplyRoomDiscountType.vue?vue&type=style&index=0&id=04354dc5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04354dc5",
  null
  
)

export default component.exports